var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('service-toolbar'),('id' in _vm.$store.service)?_c('locates',{attrs:{"service-id":_vm.$store.service.id}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }